// setShouldDisplayExploreMoreHint.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set should display explore more hint
 * @kind action
 * @param {boolean} shouldDisplayExploreMoreHint - If true, the hint will be shown; otherwise, it will be hidden.
 * @return {Object} Action.
 */
const setShouldDisplayExploreMoreHint =
  ({ shouldDisplayExploreMoreHint }) =>
  dispatch =>
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['liveStream'],
        data: {
          shouldDisplayExploreMoreHint,
        },
      },
    });
export default setShouldDisplayExploreMoreHint;
